import React, { useRef } from 'react'
import * as THREE from 'three'
import { useLoader } from '@react-three/fiber'


//const basedir = `${window.location.origin}`;
const basedir = `${process.env.PUBLIC_URL}`;

function Glass(params) {
    return (
        <meshPhysicalMaterial
            clearcoat={1}
            clearcoatRoughness={1}
            transmission={1.01}
            thickness={1.1}
            roughness={0}
            envMapIntensity={1}
            metalness={0}
            color={params.texture}
        />
    )
}

function TextureGlass(params) {
    
    const material = useRef()
    const texture = useLoader(THREE.TextureLoader, `${basedir}/textures/${params.texture}`)
    texture.wrapS = THREE.RepeatWrapping;
    texture.wrapT = THREE.RepeatWrapping;
    //repeat the wrapping 10 (x) and 6 (y) times
    texture.repeat.x = 1;
    texture.repeat.y = 1;

    return (
        <meshPhysicalMaterial
          ref={material}
          clearcoat={1}
          clearcoatRoughness={0}
          transmission={1.01}
          thickness={1.1}
          roughness={0}
          envMapIntensity={1}
          metalness={0}
          map={texture}    
          
        />
    )
}


function TextureMetal(params) {
    
    const material = useRef()
    const texture = useLoader(THREE.TextureLoader, `${basedir}/textures/${params.texture}`)
    texture.wrapS = THREE.RepeatWrapping;
    texture.wrapT = THREE.RepeatWrapping;
    //repeat the wrapping 10 (x) and 6 (y) times
    texture.repeat.x = 1;
    texture.repeat.y = 1;

    return (
        <meshPhysicalMaterial
          ref={material}
          clearcoat={0.04}
          clearcoatRoughness={1}
          //thickness={1.1}
          roughness={0.2}
          envMapIntensity={0.4}
          metalness={0.5}
          map={texture}    
          
        />
    )
}

function Metal(params) {
    return (
        <meshPhysicalMaterial
            clearcoat={0.1}
            roughness={0.1}
            envMapIntensity={0.5}
            metalness={0.8}
            color={params.texture}
        />
    )
}

function TextureMatte(params) {
    const texture = useLoader(THREE.TextureLoader, `${basedir}/textures/${params.texture}`)
    const material = useRef()
      return (
        <meshPhysicalMaterial
          ref={material}
          clearcoat={0}
          transmission={0.85}
          roughness={6}
          envMapIntensity={0.35}
          metalness={0.3}
          map={texture}    
        />
    )
}


function Matte(params) {
    return (
        <meshPhysicalMaterial
            clearcoat={0}
            transmission={0.85}
            roughness={6}
            envMapIntensity={0.35}
            metalness={0.3}
            color={params.texture}
        />
    )
}


function ShinyMetal(params) {
    return (
        <meshPhysicalMaterial
            clearcoat={0.4}
            clearcoatRoughness={1}
            //thickness={1.1}
            roughness={0}
            envMapIntensity={0.4}
            metalness={0.8}
            color={params.texture}
        />
    )
}


export default function Material(props)
{
    const m = props.material;
    const t = props.type;
    const glassTexture      = (m==='glass'||m==='door glass') && t==='image';
    const glassColor        = (m==='glass'||m==='door glass') && t==='color';
    const matteTexture      = (m==='matte'||m==='moquette'||m==='rubber')  && t==='image';
    const matteColor        = (m==='matte'||m==='moquette'||m==='rubber')  && t==='color';
    const metalTexture      = (m==='metal'||m==='alluminium') && t==='image';
    const metalColor        = (m==='metal'||m==='alluminium') && t==='color';
    const metalShinyColor   = (m==='shinymetal'||m==='steel') && t==='color';
    return(
        <>
            {glassTexture?<TextureGlass {...props} />:null}
            {matteTexture?<TextureMatte {...props} />:null}
            {metalTexture?<TextureMetal {...props} />:null}
            {glassColor?<Glass {...props} />:null}
            {matteColor?<Matte {...props} />:null}
            {metalColor?<Metal {...props} />:null}
            {metalShinyColor?<ShinyMetal {...props} />:null}
        </>
    )
}
